import React from 'react';
import {Theme, Typography, WithStyles, withStyles} from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
// @ts-ignore
import CopyToClipboardAction from 'hcla-web-frontend-primitives/app/components/primitives/Actions/CopyToClipboardAction';
import createStyles from "@material-ui/core/styles/createStyles";

const styles = (theme: Theme) => createStyles({
  root: {
    margin: `0px ${theme.spacing(1)}px`,
  },
  chipAvatar: {
    overflow: 'hidden',
    borderRadius: '24px 0px 0px 24px',
    width: '60px',
    color: 'white'
  },
});

interface Props extends WithStyles<typeof styles> {
  label: number;
}

const QRChip = (props: Props) => {
  const { label, classes, ...others } = props;

  if (label === null) return null;

  const value = Number(label).toExponential(3);

  return (
    <CopyToClipboardAction notify text={value}>
      <Chip
        classes={{
          root: classes.root,
          avatar: classes.chipAvatar,
        }}
        label={<Typography color="inherit" noWrap variant="h6">{value}</Typography>}
        color="default"
        variant="outlined"
        {...others}
      />
    </CopyToClipboardAction>
  );
};

export default withStyles(styles)(QRChip);
